import router from "@/router"
import vuexStore from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"

import {
  BestellungFiliale,
  Verzehrart,
  BPAbholungVerzehrartRequest,
  RemoteResult,
} from "mangdto"

export default class VerzehrartLogic extends BaseLogic {
  insertError: boolean = false
  insertWorking: boolean = false

  verzehrart?: Verzehrart = Verzehrart.Mitnahme

  get filiale(): BestellungFiliale {
    return this.mainLogic.filiale
  }

  verzehrarten = [
    { label: "Zum Mitnehmen", value: Verzehrart.Mitnahme },
    { label: "Verzehr im Restaurant", value: Verzehrart.VorOrt },
  ]

  init() {
    this.assignValues()
    this.mainLogic.bestellungPendingListeners.push(() => {
      this.assignValues()
    })
  }

  assignValues() {
    this.verzehrart = this.mainLogic.bestellungPending.abholung.verzehrart
  }

  weiter() {
    this.insertError = false
    this.insertWorking = true

    var request = new BPAbholungVerzehrartRequest()
    request.id = vuexStore.state.user.identifier
    request.verzehrart = this.verzehrart

    Poster.postMember<RemoteResult<any>>(
      RestPaths.bestellungpendingAbholungVerzehrart,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.mainLogic.bestellungPending.abholung.verzehrart = this.verzehrart

          router.push({ name: RouteNames.NEU.SHOPPING.PRODUKTE })
        } else {
          this.insertError = true
        }
        this.insertWorking = false
      })
      .catch(() => {
        this.insertError = true
        this.insertWorking = false
      })
  }
}
